import { Component } from 'react';
import styled from 'styled-components';

/*
 * Title系モジュール共通の親要素
 */

interface IProps {
  readonly narrowPaddingBottom: boolean;
  readonly children: React.ReactNode;
}

interface IDefaultProps {
  narrowPaddingBottom: boolean;
}

const Title = styled.header`
  padding: 12px;
`;

const ShortSpaceTitle = styled.header`
  padding: 12px 12px 4px;
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
`;
export default class ModuleTitleFrame extends Component<IProps> {
  public static defaultProps: IDefaultProps = {
    narrowPaddingBottom: false
  };
  /**
   *
   */
  public render() {
    return this.props.narrowPaddingBottom ? (
      <ShortSpaceTitle>
        <Inner>{this.props.children}</Inner>
      </ShortSpaceTitle>
    ) : (
      <Title>
        <Inner>{this.props.children}</Inner>
      </Title>
    );
  }
}
